export default __webpack_public_path__ + "static/media/about.fba81b8d.jpg";